import AppCSS from '../../../../../utils/styled';
import styled from 'styled-components';
import { DefaultModalComponents } from '../../../../../components/ProjectModal/utils';

export const Components = {
  ...DefaultModalComponents,
  TableWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    ${AppCSS.boxShadows.block};
  `,

  UploadButton: styled.label`
    min-width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${AppCSS.colors.white};
    padding: 12px 24px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.black};
    cursor: pointer;
  `,
  FieldWrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  FieldLabel: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
  `,
};
